import { useState, useCallback } from 'react';
import { KEY_VALUES } from '../utils';
export function transformData(data, categoryKey) {
  if (!data) {
    return [];
  }
  data.map(function (item) {
    if (typeof item === 'string') {
      return {
        value: item,
        label: item
      };
    }
    if (typeof item === 'object') {
      return item;
    }
  });
  data = flattenArray(data, categoryKey, null);
  data = categorize(data, categoryKey);
  return data;
}
var flattenArray = function flattenArray(data, categoryKey, categoryList) {
  var result = [];
  for (var i = 0, len = data.length; i < len; i++) {
    if (!data[i].children) {
      if (categoryList !== null) {
        data[i][categoryKey] = categoryList;
      }
      result.push(data[i]);
    } else {
      var subArr = data[i].children;
      var newCategoryList = categoryList !== null ? categoryList + ' > ' + data[i][categoryKey] : data[i][categoryKey];
      result = [].concat(result, flattenArray(subArr, categoryKey, newCategoryList));
    }
  }
  return result;
};
var categorize = function categorize(data, categoryKey) {
  var categoryList = [];
  var result = [];
  for (var i = 0, len = data.length; i < len; i++) {
    var index = categoryList.indexOf(data[i][categoryKey]);
    if (index > -1) {
      result[index].push(data[i]);
    } else {
      categoryList.push(data[i][categoryKey]);
      result.push([data[i]]);
    }
  }
  if (result.length > 0) result = result.reduce(function (a, b) {
    return a.concat(b);
  });
  return result;
};
export var shouldDisplay = function shouldDisplay(filterBy, searchValue, value, labelKey, categoryKey) {
  return function (item) {
    if (typeof filterBy === 'function') {
      return filterBy(value, item);
    }
    if (value.length > 0) {
      return value === item[labelKey];
    }
    if (!searchValue.trim()) {
      return false;
    }
    var keyword = (searchValue.trim() || '').toLocaleLowerCase();
    if (item[categoryKey] && item[categoryKey].toLocaleLowerCase().indexOf(keyword) >= 0) {
      return true;
    }
    return "" + item[labelKey] !== 'undefined' ? ("" + item[labelKey]).toLocaleLowerCase().indexOf(keyword) >= 0 : false;
  };
};
function isFunction(target) {
  return typeof target === 'function';
}
export function onMenuKeyDown(event, events, callbackFunc, keydownTabEvent) {
  event.stopPropagation();
  var down = events.down,
    up = events.up,
    enter = events.enter,
    del = events.del,
    esc = events.esc,
    right = events.right,
    left = events.left;
  switch (event.key) {
    // down
    case KEY_VALUES.DOWN:
      down === null || down === void 0 ? void 0 : down(event);
      callbackFunc === null || callbackFunc === void 0 ? void 0 : callbackFunc();
      event.preventDefault();
      break;
    // up
    case KEY_VALUES.UP:
      up === null || up === void 0 ? void 0 : up(event);
      callbackFunc === null || callbackFunc === void 0 ? void 0 : callbackFunc();
      event.preventDefault();
      break;
    // enter
    case KEY_VALUES.ENTER:
      enter === null || enter === void 0 ? void 0 : enter(event);
      event.preventDefault();
      break;
    // delete
    case KEY_VALUES.BACKSPACE:
      del === null || del === void 0 ? void 0 : del(event);
      break;
    // esc | tab
    case KEY_VALUES.ESC:
      // case KEY_VALUES.TAB:
      esc === null || esc === void 0 ? void 0 : esc(event);
      break;
    // left arrow
    case KEY_VALUES.LEFT:
      left === null || left === void 0 ? void 0 : left(event);
      break;
    // right arrow
    case KEY_VALUES.RIGHT:
      right === null || right === void 0 ? void 0 : right(event);
      break;
    case KEY_VALUES.SPACE:
      enter === null || enter === void 0 ? void 0 : enter(event);
    // event.preventDefault();
    default:
  }
  keydownTabEvent === null || keydownTabEvent === void 0 ? void 0 : keydownTabEvent(event);
}
export var useFocusItemValue = function useFocusItemValue(defaultFocusItemValue, props) {
  var _props$valueKey = props.valueKey,
    valueKey = _props$valueKey === void 0 ? 'value' : _props$valueKey,
    items = props.items,
    callback = props.callback;
  var _useState = useState(defaultFocusItemValue),
    focusItemValue = _useState[0],
    setFocusItemValue = _useState[1];
  var getFocusableMenuItems = useCallback(function () {
    if (!items || items.length === 0) {
      return [];
    }
    return items.filter(function (item) {
      return !item.disabled;
    });
  }, [items]);

  /**
   * Get the index of the focus item.
   */
  var findFocusItemIndex = useCallback(function (callback) {
    var items = getFocusableMenuItems();
    for (var i = 0; i < items.length; i += 1) {
      var _items$i;
      if (focusItemValue === ((_items$i = items[i]) === null || _items$i === void 0 ? void 0 : _items$i[valueKey])) {
        callback(items, i);
        return;
      }
    }
    callback(items, -1);
  }, [focusItemValue, getFocusableMenuItems, valueKey]);
  var focusNextMenuItem = useCallback(function (event) {
    findFocusItemIndex(function (items, index) {
      var nextIndex = index + 2 > items.length ? 0 : index + 1;
      var focusItem = items[nextIndex];
      if (typeof focusItem !== 'undefined') {
        setFocusItemValue(focusItem[valueKey]);
        callback === null || callback === void 0 ? void 0 : callback(focusItem[valueKey], event);
      }
    });
  }, [callback, findFocusItemIndex, valueKey]);
  var focusPrevMenuItem = useCallback(function (event) {
    findFocusItemIndex(function (items, index) {
      var nextIndex = index === 0 ? items.length - 1 : index - 1;
      var focusItem = items[nextIndex];
      if (typeof focusItem !== 'undefined') {
        setFocusItemValue(focusItem[valueKey]);
        callback === null || callback === void 0 ? void 0 : callback(focusItem[valueKey], event);
      }
    });
  }, [callback, findFocusItemIndex, valueKey]);
  var handleKeyDown = useCallback(function (event) {
    onMenuKeyDown(event, {
      down: focusNextMenuItem,
      up: focusPrevMenuItem
    });
  }, [focusNextMenuItem, focusPrevMenuItem]);
  return {
    focusItemValue: focusItemValue,
    setFocusItemValue: setFocusItemValue,
    onKeyDown: handleKeyDown
  };
};